<template>
  <v-row>
    <v-col class="py-0">
      <div class="tcdc-calendar-card-component" :class="{ 'calendar-card-active': eventIsActive }">
        <div class="tcdc-calendar-card-component-inside d-flex flex-column pa-8">
          <div v-if="eventIsActive" class="d-flex align-center justify-space-between">
              <span class="sub-header1 bold text-tcdc-green calendar-card-highlight">{{ localeDayNow }}</span>
              <span class="sub-header1 bold text-tcdc-green calendar-card-highlight">{{ localeMonthNow }}</span>
          </div>
          <div v-else class="d-flex align-center justify-space-between">
              <span class="sub-header1 bold text-tcdc-green calendar-card-highlight">{{localeDay}}</span>
              <span class="sub-header1 bold text-tcdc-green calendar-card-highlight">{{localeMonth}}</span>
          </div>
          <div class="d-flex flex-1 py-3">
            <span
              class="sub-header1 bold text-tcdc-green calendar-card-highlight"
            >{{name}}</span>
          </div>
          <div class="d-flex align-end justify-space-between">
            <div class="d-flex align-start">
              <img
                src="../../assets/icons/marker.png"
                class="tcdc-calendar-card-icon-marker mr-2 calendar-card-image-highlight"
              />
              <span class="bold text-tcdc-green calendar-card-highlight">{{location}}</span>
            </div>
            <!-- <div class="d-flex align-end">
              <img
                src="../../assets/icons/noti.png"
                class="tcdc-calendar-card-icon-noti calendar-card-image-highlight"
              />
            </div>-->
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import { mapState } from 'vuex';
  import moment from "moment";
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    },
    location: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang
    }),
    eventIsActive: function () {
      let now = new Date();
      let start = moment(this.date).toDate();
      let end = moment(this.endDate).toDate();
      return now >= start && now <= end;
    },
    localeDay: function () {
      return moment(this.date).locale(this.lang === 'en' ? 'en':'th').format('DD');
    },
    localeMonth: function () {
      return moment(this.date).locale(this.lang === 'en' ? 'en':'th').format('MMM');
    },
    localeDayNow: function () {
      return moment(new Date()).locale(this.lang === 'en' ? 'en':'th').format('DD');
    },
    localeMonthNow: function () {
      return moment(new Date()).locale(this.lang === 'en' ? 'en':'th').format('MMM');
    }
  }
};
</script>

<style lang="scss" scoped>
.tcdc-calendar-card-component {
  overflow: hidden;
  height: 0;
  padding-top: 100%;
  border: 2px solid $tcdcGreen;
  background-color: white;
  position: relative;
}
.tcdc-calendar-card-component:hover,
.calendar-card-active {
  background-color: $tcdcGreen;
  .calendar-card-highlight {
    color: white !important;
  }
  .calendar-card-image-highlight {
    filter: brightness(0) invert(1);
  }
}
.tcdc-calendar-card-component-inside {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.tcdc-calendar-card-icon-marker {
  width: 15px;
  object-fit: contain;
}
.tcdc-calendar-card-icon-noti {
  width: 20px;
  object-fit: contain;
}
</style>
